import { IContextMenuItem } from '@smartshell/ui-kit';

import { openConfirmDialog } from 'services/Confirmation';
import { getUniqueSortedBookings } from 'utils';

import { CtxMenuHost } from '../interfaces';
import { TGetBookingItem } from './interfaces';

export const getBookingItem: TGetBookingItem = ({
  t,
  isBookingAvailable,
  openAllBookingsModal,
  openBookingModal,
  redeemBooking,
  permissions,
  selectedHostsIds,
  hosts,
}) => {
  const selectedHosts = hosts?.filter((host) =>
    selectedHostsIds?.includes(host.id)
  );
  const bookingSubMenu: Array<IContextMenuItem<CtxMenuHost>> = [
    {
      key: 'booking-open',
      text: t('host.ctx.bookings.book'),
      iconName: 'CirclePlusIcon',
      onClick: openBookingModal,
    },
    {
      key: 'booking-list',
      text: t('host.ctx.bookings.list'),
      iconName: 'ListIcon',
      onClick: openAllBookingsModal,
      disabled: selectedHostsIds?.length !== 1,
      isLastInGroup: true,
    },
    {
      key: 'booking-confirm',
      text: () => {
        if (
          selectedHosts?.some(
            (host) => host.bookings.length && !host.bookings?.[0]?.byClient
          ) ||
          (selectedHosts?.length === 1 &&
            !selectedHosts[0].bookings?.[0]?.byClient)
        )
          return t('host.ctx.bookings.confirm');
        return t('setting.onlineBooking');
      },
      disabled: () => {
        if (
          selectedHosts !== undefined &&
          !selectedHosts?.some((host) => host.bookings.length)
        )
          return true;
        if (
          selectedHosts?.every(
            (host) => host.bookings?.[0]?.byClient || !host.bookings.length
          )
        )
          return true;

        return false;
      },
      iconName: 'CheckIcon',
      onClick: () => {
        const uniqueDialogData = getUniqueSortedBookings(selectedHosts, hosts);

        openConfirmDialog(t, 'booking', {
          title: t('modal.confirm.booking.title'),
          acceptTitle: t('confirm'),
          declineTitle: t('cancel_2'),
          dialogData: uniqueDialogData ?? [],
        }).then(({ status }) => {
          if (status === 'ACCEPTED') {
            if (selectedHostsIds?.length === 1 && selectedHosts)
              return redeemBooking({
                variables: { id: selectedHosts[0].bookings[0].id },
              });
            if (selectedHostsIds && selectedHostsIds?.length > 1) {
              selectedHosts?.forEach((host) => {
                if (host.bookings.length && !host.bookings[0].byClient) {
                  const nearestBooking = host.bookings[0];
                  return redeemBooking({
                    variables: { id: nearestBooking.id },
                  });
                }
              });
            }
          }
        });
      },
    },
  ];
  return !permissions?.has('booking_manage')
    ? null
    : {
        key: 'booking',
        text: t('booking'),
        iconName: 'CalendarIcon',
        subMenu: bookingSubMenu,
        disabled: ({ locked }) => !isBookingAvailable || locked,
      };
};
